module.exports = __webpack_public_path__ + "img/mind_template_item_1_1.7d970b52.png";